/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_EnableInputs */

const en_settings_enable = /** @type {(inputs: Settings_EnableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enable notifications`)
};

const he_settings_enable = /** @type {(inputs: Settings_EnableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`הפעלת התראות`)
};

/**
* | output |
* | --- |
* | "Enable notifications" |
*
* @param {Settings_EnableInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const settings_enable = /** @type {((inputs?: Settings_EnableInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_EnableInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_enable(inputs)
	return he_settings_enable(inputs)
});